import React from "react";
import Settings from "./Settings_Context";

const joinProps = (a, b) => {
  return {
    ...a,
    ...b,
  };
};
export default (Compo, mapContext) => {
  return (props) => {
    return (
      <Settings.Consumer>
        {(context) => <Compo {...joinProps(props, mapContext(context))} />}
      </Settings.Consumer>
    );
  };
};
